import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot, hydrateRoot } from 'react-dom/client';

interface MountOptions {
  hydrate: boolean;
  onRecoverableError: (error: Error) => void;
}

/**
 * react/react-dom are webpack externals resolved to the UMD globals injected by the SSR HTML.
 * Until the React 18 server is rolled out everywhere (and in statics-override environments
 * such as sled PR runs, where production SSR still injects React 16), the page-level ReactDOM
 * may not provide the react-dom/client APIs — fall back to the legacy mount API in that case.
 */
export function mountReactApp(container: Element, application: React.ReactElement, options: MountOptions): void {
  if (typeof createRoot !== 'function') {
    if (options.hydrate) {
      // eslint-disable-next-line react/no-deprecated
      ReactDOM.hydrate(application, container);
    } else {
      // eslint-disable-next-line react/no-deprecated
      ReactDOM.render(application, container);
    }
    return;
  }

  if (options.hydrate) {
    hydrateRoot(container, application, {
      onRecoverableError: (error) => {
        options.onRecoverableError(error as Error);
      },
    });
  } else {
    createRoot(container).render(application); // root ref not stored — mount is permanent for this SPA
  }
}
